"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapProfileQueryKapiToProfileCX = exports.mapToLegacyAddress = void 0;
var mapToLegacyAddress = function (json) {
    try {
        var parsed = JSON.parse(json);
        var line1 = parsed.line1, line2 = parsed.line2, town = parsed.town, postcode = parsed.postcode;
        return [line1, line2, town, postcode].filter(function (v) { return typeof v === 'string'; });
    }
    catch (_a) {
        return [];
    }
};
exports.mapToLegacyAddress = mapToLegacyAddress;
var mapProfileQueryKapiToProfileCX = function (data) {
    if (!data || !data.customer) {
        return null;
    }
    var _a = data.customer, formattedAddresses = _a.formattedAddresses, rest = __rest(_a, ["formattedAddresses"]);
    return __assign(__assign({}, rest), { address: formattedAddresses[0]
            ? (0, exports.mapToLegacyAddress)(formattedAddresses[0].address)
            : [], accountNo: data.account.accountNo });
};
exports.mapProfileQueryKapiToProfileCX = mapProfileQueryKapiToProfileCX;
